import { rgba } from 'polished'
import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;
  width: 100%;
  max-width: 1120px;
  height: 100%;
  max-height: 100vh;
  padding: 2rem 3rem;
  margin: auto;

  overflow-y: auto;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 0px;
    width: 100vw;
    height: inherit;

    background: url('/images/bgProject.svg') no-repeat top center;
    transform: translate(-51.5%, 0%);

    filter: blur(4px);
    opacity: 0.6;
    z-index: -1;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  h1 {
    font-size: 10rem;
    font-weight: 600;
    letter-spacing: -1px;
    word-break: break-all;

    color: ${props => props.theme.colors.text.title};
  }

  img,
  svg {
    vertical-align: middle;
  }

  h3 {
    /* position: sticky; */
    top: -3.6%;
    height: 4rem;
    margin: 7rem 0px 0.8rem 0px;

    color: #fff;
    /* backdrop-filter: blur(10px); */

    font-size: 30px;
    line-height: 30px;
    font-weight: 400;
    letter-spacing: 0.8px;

    display: flex;
    align-items: center;

    z-index: 10;
  }
  section {
    .loading-state {
      width: 100%;
      min-height: 5rem;
      padding: 1.5rem;

      font-size: 1rem;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.75rem;
      color: ${props => rgba(props.theme.colors.text.light, 0.65)};

      button {
        border: 0;
        border-radius: 999px;
        padding: 0.55rem 1rem;
        background: ${props => rgba(props.theme.colors.primary.normal, 0.18)};
        color: ${props => props.theme.colors.text.light};
        cursor: pointer;
        transition: background 0.2s ease;

        &:hover {
          background: ${props => rgba(props.theme.colors.primary.normal, 0.32)};
        }
      }
    }

    .spinner {
      width: 1.1rem;
      height: 1.1rem;
      border: 2px solid ${props => rgba(props.theme.colors.text.light, 0.25)};
      border-top-color: ${props => props.theme.colors.primary.normal};
      border-radius: 50%;
      animation: projects-spinner 0.8s linear infinite;
    }

    @keyframes projects-spinner {
      to {
        transform: rotate(360deg);
      }
    }

    ul {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -0.75rem;

      list-style: none;

      li {
        flex-shrink: 0;
        width: 50%;
        max-width: 50%;
        padding: 1.5rem 0.75rem 0;
        perspective: 1000;

        > a {
          display: block;
          color: inherit;
          text-decoration: none;
        }
      }
    }
  }

  @media (max-width: 992px) {
    max-width: 960px;

    section {
      ul li {
        width: 100%;
        max-width: 100%;
      }
    }
  }

  @media (max-width: 768px) {
    max-width: 720px;
  }
  @media (max-width: 576px) {
    max-width: 540px;
    width: 100%;
    padding: 2rem 2rem;
    margin-right: auto;
    margin-left: auto;

    h1 {
      font-size: 6rem;
      line-height: 6rem;
    }

    section {
      ul li {
        width: 100%;
        max-width: 100%;

        .card {
          margin: 0;
        }
      }
    }
  }
`

export const Card = styled.div.attrs(() => ({
  className: 'card'
}))`
  background-color: ${props => rgba(props.theme.colors.white, 0.01)};
  backdrop-filter: blur(10px);
  color: ${props => rgba(props.theme.colors.text.light, 0.6)};
  border: 1px solid ${props => rgba(props.theme.colors.white, 0.1)};
  border-radius: 10px;

  overflow: hidden;
  transition: all 0.4s ease;
  margin: 0;

  &:hover {
    transform: scale(1.02);
    border: 2px solid ${props => props.theme.colors.primary.normal};

    .thumbnail img {
      transform: scale(1.1) rotateZ(-4deg);
    }
  }

  .thumbnail {
    width: 100%;
    aspect-ratio: 16 / 9;
    overflow: hidden;
  }

  .thumbnail img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;

    transition: transform 0.4s ease;
  }

  .title-box {
    padding: 20px;

    .title {
      color: ${props => props.theme.colors.text.light};
      font-size: 1.2rem;
      letter-spacing: 0.5px;
      line-height: 24px;
      margin-bottom: 1rem;
    }
    .description {
      font-size: 14px;
      line-height: 22px;
      font-weight: 300;
      padding-bottom: 0px;
      /* color: #8193b2; */

      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
    }
  }
`
